import React from 'react';

import { TextArea } from 'semantic-ui-react';
import FormbuilderFieldWrapper from './formbuilderFieldWrapper';

class FormbuilderTextArea extends React.Component {

    render() {
        const { onChange, value, identifier, placeholder, label, validation, error, errorMessage, onBlur, inputSub, popup, initialValidation } = this.props;

        return (
            <FormbuilderFieldWrapper
                key={identifier}
                label={label}
                validation={validation}
                error={error}
                errorMessage={errorMessage}
                onBlur={onBlur}
                inputSub={inputSub}
                popup={popup}
                value={value}
                initialValidation={initialValidation}>
                <TextArea id='formbuilder-textarea'
                    onChange={onChange}
                    value={value}
                    placeholder={placeholder} />
            </FormbuilderFieldWrapper>
        );
    }
}

export default FormbuilderTextArea;